export enum ActionType {
    SET_USER = 'SET_USER',
    MEETING_ID ="MEETING_ID"
}